/* ==========================================================================
   SERPROMAQ - MARCAS RESPALDADAS
   ========================================================================== */

export const BRANDS = [
  { id: 'toyota', name: 'TOYOTA', tagline: 'Material Handling' },
  { id: 'caterpillar', name: 'CAT', tagline: 'Lift Trucks' },
  { id: 'hyster', name: 'HYSTER', tagline: 'Strong & Tough' },
  { id: 'crown', name: 'CROWN', tagline: 'Equipment' },
  { id: 'komatsu', name: 'KOMATSU', tagline: 'Forklifts' },
  { id: 'mitsubishi', name: 'MITSUBISHI', tagline: 'Logistics' },
  { id: 'yale', name: 'YALE', tagline: 'Materials Handling' },
  { id: 'clark', name: 'CLARK', tagline: 'The Forklift' },
  { id: 'nissan', name: 'NISSAN', tagline: 'Forklift' }
];
